<template>
    <div id="elle-register" class="elle-register">
        <div class="elle-register-wrapper">
            <Form
                ref="$register"
                class="elle-register-form"
                :class="{ loading: loading }"
                enctype="multipart/form-data"
                method="POST"
                accept-charset="UTF-8"
                autocomplete="off"
                :initial-values="registerFormValues"
                :validation-schema="schema"
                @submit="onSubmitForm"
                @invalid-submit="onInvalidSubmitFrm"
            >
                <div class="fields">
                    <div class="cols">
                        <div class="row">
                            <div class="field-group">
                                <label for="c-firstname" class="field-label">{{ $t('forms.register.label_first_name') }}</label>
                                <Field
                                    id="c-firstname"
                                    name="c-firstname"
                                    type="text"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_first_name')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="field-group">
                                <label for="c-lastname" class="field-label">{{ $t('forms.register.label_last_name') }}</label>
                                <Field
                                    id="c-lastname"
                                    name="c-lastname"
                                    type="text"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_last_name')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="field-group">
                                <label for="c-date-of-birth" class="field-label">{{ $t('forms.register.label_date_of_birth') }}</label>
                                <Field
                                    id="c-date-of-birth"
                                    name="c-date-of-birth"
                                    type="date"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_date_of_birth')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="field-group">
                                <label for="c-first-day-last-menstruation" class="field-label">{{
                                    $t('forms.register.label_first_day_last_menstruation')
                                }}</label>
                                <Field
                                    id="c-first-day-last-menstruation"
                                    name="c-first-day-last-menstruation"
                                    type="date"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_first_day_last_menstruation')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="cols">
                        <div class="row">
                            <div class="field-group">
                                <label for="c-email" class="field-label">{{ $t('forms.register.label_email') }}</label>
                                <Field
                                    id="c-email"
                                    name="c-email"
                                    type="email"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_email')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="field-group">
                                <label for="c-phone" class="field-label">{{ $t('forms.register.label_phone') }}</label>
                                <Field
                                    id="c-phone"
                                    name="c-phone"
                                    type="tel"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_phone')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="field-group">
                                <label for="c-street-house-number" class="field-label">{{ $t('forms.register.label_street_house_number') }}</label>
                                <Field
                                    id="c-street-house-number"
                                    name="c-street-house-number"
                                    type="text"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_street_house_number')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="field-group">
                                <label for="c-postal-code" class="field-label">{{ $t('forms.register.label_postal_code') }}</label>
                                <Field
                                    id="c-postal-code"
                                    name="c-postal-code"
                                    type="text"
                                    autocomplete="off"
                                    class="form-field"
                                    :placeholder="$t('forms.register.placeholder_postal_code')"
                                    @blur="formInputBlur"
                                    @focus="formInputFocus"
                                    @change="formObjectOnChange"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="field-group">
                            <label for="c-location" class="field-label">{{ $t('forms.register.label_location') }}</label>
                            <Field
                                id="c-location"
                                name="c-location"
                                as="select"
                                autocomplete="off"
                                class="form-field form-select"
                                :placeholder="$t('forms.register.placeholder_location')"
                                @blur="formInputBlur"
                                @focus="formInputFocus"
                                @change="formObjectOnChange"
                            >
                                <option value="" disabled>{{ $t('forms.register.placeholder_location') }}</option>
                                <option v-for="location in locations" :key="location.id" :value="location.slug">
                                    {{ location.title }}
                                </option>
                            </Field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="field-group">
                            <label for="c-message" class="field-label">{{ $t('forms.register.label_message') }}</label>
                            <Field
                                id="c-message"
                                name="c-message"
                                as="textarea"
                                autocomplete="off"
                                class="form-field textarea"
                                :placeholder="$t('forms.register.placeholder_message')"
                                @blur="formInputBlur"
                                @focus="formInputFocus"
                                @change="formObjectOnChange"
                            />
                        </div>
                    </div>

                    <div class="row w-padd">
                        <div class="field-group is-checkbox">
                            <Field
                                id="c-privacy"
                                name="c-privacy"
                                type="checkbox"
                                autocomplete="off"
                                :value="true"
                                :unchecked-value="false"
                                class="form-checkbox"
                                @blur="formInputBlur"
                                @focus="formInputFocus"
                                @change="formObjectOnChange"
                            />
                            <label ref="$privacy" for="c-privacy" class="checkbox-label" v-html="privacyPolicy" />
                        </div>
                    </div>

                    <div class="row w-padd">
                        <div class="field-group">
                            <button :disabled="loading" class="form-submit elle-btn black" type="submit" :title="$t('forms.register.btn_register')">
                                <span class="text">{{ !loading ? $t('forms.register.btn_register') : $t('forms.register.btn_sending') }}</span>
                                <span class="icon">
                                    <UiSvgArrowLeft v-show="!loading" />
                                    <UiSvgLoader v-show="loading" />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Form>

            <div ref="$success" class="elle-register-form-success">
                <button
                    type="button"
                    class="success-close"
                    :title="$t('site.label_close')"
                    :aria-label="$t('site.label_close')"
                    @click="closeSuccessMessage"
                >
                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect class="vert" x="15.75" width="1.5" height="33" fill="black" />
                        <rect class="horiz" y="17.2489" width="1.5" height="33" transform="rotate(-90 0 17.2489)" fill="black" />
                    </svg>
                </button>
                <div class="content typography" v-html="success" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Form, Field } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import validator from 'validator';
import Botpoison from '@botpoison/browser';
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        privacyPolicy?: string;
        success?: string;
        locations?: CmsItem[];
    }>(),
    {
        privacyPolicy: '',
        success: '',
        locations: () => []
    }
);

const { $gsap: gsap } = useNuxtApp();

const { t } = useI18n();
const loading = ref(false);
const sended = ref(false);
const route = useRoute();
const runtimeConfig = useRuntimeConfig();
const registerBotpoisonPublicKey = runtimeConfig.public.botpoisonRegisterPk;
const privacyPolicy = computed(() => props.privacyPolicy);
const success = computed(() => props.success);
const locations = computed(() => props.locations);
const $privacy = ref<HTMLLabelElement | null>(null);
const $success = ref<HTMLDivElement | null>(null);

type RegisterFieldValue = string | boolean | null | undefined;
type RegisterValues = Record<string, RegisterFieldValue>;
type InvalidSubmitResult = { valid: boolean };
type FormFieldElement = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
type ResetFormActions = { resetForm: () => void };

const initialLocation = Array.isArray(route.query.location) ? (route.query.location[0] ?? '') : ((route.query.location as string | undefined) ?? '');

const registerFormValues = ref({
    'c-location': initialLocation,
    'c-privacy': false
});

const isValidPhoneNumber = (phone: string) => {
    const normalizedPhone = phone.replace(/[\s().-]/g, '');

    return /^\+?\d+$/.test(normalizedPhone) && validator.isLength(normalizedPhone.replace(/^\+/, ''), { min: 8, max: 15 });
};

const zodObj = z.object({
    'c-firstname': z
        .string({
            required_error: t('forms.register.error_first_name')
        })
        .refine(name => name.trim() !== '', {
            message: t('forms.register.error_first_name')
        }),
    'c-lastname': z
        .string({
            required_error: t('forms.register.error_last_name')
        })
        .refine(name => name.trim() !== '', {
            message: t('forms.register.error_last_name')
        }),
    'c-date-of-birth': z.string().optional(),
    'c-first-day-last-menstruation': z.string().optional(),

    'c-email': z
        .string({
            required_error: t('forms.register.error_email')
        })
        .email(t('forms.register.valid_email')),

    'c-phone': z
        .string({
            required_error: t('forms.register.error_phone')
        })
        .refine(phone => isValidPhoneNumber(phone), { message: t('forms.register.valid_phone') }),
    'c-street-house-number': z.string().optional(),
    'c-postal-code': z.string().optional(),

    'c-message': z.string().optional(),

    'c-location': z
        .string({
            required_error: t('forms.register.error_location')
        })
        .refine(location => location.trim() !== '', {
            message: t('forms.register.error_location')
        }),

    'c-privacy': z
        .boolean({
            required_error: t('forms.register.error_privacy')
        })
        .refine(privacy => privacy === true, {
            message: t('forms.register.error_privacy')
        })
});

const schema = toTypedSchema(zodObj);

const closeSuccessMessage = () => {
    if (!$success.value || !sended.value) {
        return;
    }

    gsap.to($success.value, {
        opacity: 0,
        visibility: 'hidden',
        duration: 0.4,
        ease: 'power1.out',
        onComplete: () => {
            sended.value = false;
        }
    });
};

const onSubmitForm = async (values: RegisterValues, actions: ResetFormActions) => {
    loading.value = true;
    sended.value = false;

    try {
        let botpoisonSolution = '';

        if (registerBotpoisonPublicKey) {
            const botpoison = new Botpoison({
                publicKey: registerBotpoisonPublicKey
            });
            const challenge = await botpoison.challenge();

            botpoisonSolution = challenge.solution;
        } else if (import.meta.dev) {
            console.warn('Missing NUXT_ELLE_REGISTER_BOTPOISON_PK, submitting register form without Botpoison.');
        }

        const formData: Record<string, string> = {
            fname: typeof values['c-firstname'] === 'string' ? values['c-firstname'] : '',
            lname: typeof values['c-lastname'] === 'string' ? values['c-lastname'] : '',
            dateOfBirth: typeof values['c-date-of-birth'] === 'string' ? values['c-date-of-birth'] : '',
            firstDayOfLastMenstruation: typeof values['c-first-day-last-menstruation'] === 'string' ? values['c-first-day-last-menstruation'] : '',
            email: typeof values['c-email'] === 'string' ? values['c-email'] : '',
            phone: typeof values['c-phone'] === 'string' ? values['c-phone'] : '',
            streetAndHouseNumber: typeof values['c-street-house-number'] === 'string' ? values['c-street-house-number'] : '',
            postalCode: typeof values['c-postal-code'] === 'string' ? values['c-postal-code'] : '',
            location: typeof values['c-location'] === 'string' ? values['c-location'] : '',
            message: typeof values['c-message'] === 'string' ? values['c-message'] : ''
        };

        if (botpoisonSolution) {
            formData._botpoison = botpoisonSolution;
        }

        const response = await fetch(`https://submit-form.com/u6JexwiB`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(formData)
        });

        if (!response.ok) {
            throw new Error(`Register submission failed with status ${response.status}`);
        }

        trackAppointmentBooked(formData.location);

        gsap.to($success.value!, {
            opacity: 1,
            visibility: 'visible',
            duration: 1,
            ease: 'power1',
            onComplete: () => {
                actions.resetForm();
                sended.value = true;
            }
        });
    } catch (error) {
        console.error('Register form submit failed:', error);
    } finally {
        loading.value = false;
    }
};

const onInvalidSubmitFrm = async ({
    errors,
    results
}: {
    errors: Partial<Record<string, string>>;
    results: Partial<Record<string, InvalidSubmitResult>>;
}) => {
    const requiredFieldOrder = ['c-firstname', 'c-lastname', 'c-email', 'c-phone', 'c-location', 'c-privacy'] as const;
    const firstRequiredErrorKey = requiredFieldOrder.find(field => Boolean(errors[field]));
    const firstErrorKey = firstRequiredErrorKey ?? Object.keys(errors)[0];

    if (firstErrorKey) {
        const el = document.getElementById(firstErrorKey);
        if (el) {
            el.focus();
        }
    }

    if (import.meta.dev) {
        console.warn('Register form validation failed:', errors);
    }

    for (const [key, value] of Object.entries(results)) {
        const el = document.getElementById(key);
        const parent = el?.parentElement;
        if (el && parent && value) {
            if (!value.valid) {
                parent.classList.add('hasError');
            } else {
                parent.classList.remove('hasError');
            }
        }
    }
};

const formInputFocus = (e: Event) => {
    const target = e.target as FormFieldElement;
    target.parentElement?.classList.add('focused');
};

const formInputBlur = (e: Event) => {
    const target = e.target as FormFieldElement;
    if (target.value === '') {
        target.classList.remove('filled');
        target.parentElement?.classList.remove('focused');
    } else {
        target.classList.add('filled');
    }
};

const formObjectOnChange = (e: Event) => {
    const target = e.target as FormFieldElement;
    if (target.value !== '') {
        target.classList.add('hasValue');
    } else {
        target.classList.remove('hasValue');
    }
};

onMounted(() => {
    if ($privacy.value) {
        const links = $privacy.value.querySelectorAll('a');
        if (links) {
            links.forEach(link => link.classList.add('elle-animated-link', 'elle-animated-link-flash'));
        }
    }
});
</script>
